import { format } from 'fecha';
import { IServiceResult } from '../../infrastructure/Interfaces/IServiceResult';
import { SVCDatosPersonales } from '../../infrastructure/services/api/SVCDatosPersonales';
import IViewDatosPersonales from '../../presentation/view-interfaces/IViewDatosPersonales';
import IViewRepresentanteFinanciero from '../../presentation/view-interfaces/IViewTipoPersona';
import IViewRepresentanteFinancieroCmb from '../../presentation/view-interfaces/IViewTipoPersonaCmb';

export const ObtieneDatosPersonales = (
    selListaPersona: any,
    rut: number,
    pasaporte: string,
    codigoNegocio: number,
    tipoPersona: number,
    idPeriodo: number,
    Postulaciones: any,
    headers: any
) => {
    let list: Array<IViewDatosPersonales> = [];
    SVCDatosPersonales.ObtieneDatosPersonales(rut, pasaporte, codigoNegocio, tipoPersona, idPeriodo, headers).then(
        (res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                list.push({
                    idPersona: data.idPersona,
                    run: data.run,
                    dv: data.dv === null || data.dv === undefined ? '' : data.dv,
                    pasaporte: data.pasaporte === null || data.pasaporte === undefined ? '' : data.pasaporte.trim(),
                    nombres: data.nombres === null || data.nombres === undefined ? '' : data.nombres.trim(),
                    primerApellido:
                        data.primerApellido === null || data.primerApellido === undefined
                            ? ''
                            : data.primerApellido.trim(),
                    segundoApellido: (data.segundoApellido === null || data.segundoApellido === undefined
                        ? ''
                        : data.segundoApellido
                    ).trim(),
                    fechaNacimiento:
                        data.fechaNacimiento === null || data.fechaNacimiento === undefined ? '' : data.fechaNacimiento,
                    esMenorEdad: data.esMenorEdad,
                    codigoComuna: data.codigoComuna,
                    nombreComuna:
                        data.nombreComuna === null || data.nombreComuna === undefined ? '' : data.nombreComuna.trim(),
                    direccion: data.direccion === null || data.direccion === undefined ? '' : data.direccion.trim(),
                    telefono: data.telefono,
                    email: data.email === null || data.email === undefined ? '' : data.email.trim(),
                    emailUDD: data.emailUDD === null || data.emailUDD === undefined ? '' : data.emailUDD.trim(),
                    codSexo: data.codSexo,
                    sexo: data.sexo === null || data.sexo === undefined ? '' : data.sexo.trim(),
                    idPais: data.idPais,
                    pais: data.pais === null || data.pais === undefined ? '' : data.pais.trim(),
                    idNacionalidad: data.idNacionalidad,
                    nacionalidad:
                        data.nacionalidad === null || data.nacionalidad === undefined ? '' : data.nacionalidad.trim(),
                    runFormato: data.runFormato === null || data.runFormato === undefined ? '' : data.runFormato.trim(),
                    nombreCompleto:
                        data.nombreCompleto === null || data.nombreCompleto === undefined
                            ? ''
                            : data.nombreCompleto.trim(),
                });
                selListaPersona(false, '', list, Postulaciones);
            } else {
                selListaPersona(true, res.errorDetails, list, Postulaciones);
            }
        },
    );
};

export const GrabarDatosPersonales = (
    selGrabarDatosPersonales: any,
    headers: any,
    idPersona: number,
    run: string,
    pasaporte: string,
    nombres: string,
    primerApellido: string,
    segundoApellido: string,
    fechaNacimiento: Date,
    codigoComuna: number,
    nombreComuna: string,
    direccion: string,
    telefono: number,
    email: string,
    codSexo: number,
    sexo: string,
    idPais: number,
    pais: string,
    idNacionalidad: number,
    nacionalidad: string,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    tipoPersona: number,
    Postulaciones: any
) => {
    SVCDatosPersonales.GrabarDatosPersonales(
        headers,
        idPersona,
        run,
        pasaporte,
        nombres,
        primerApellido,
        segundoApellido,
        fechaNacimiento,
        codigoComuna,
        nombreComuna,
        direccion,
        telefono,
        email,
        codSexo,
        sexo,
        idPais,
        pais,
        idNacionalidad,
        nacionalidad,
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        tipoPersona,
        'MATWEB'
    ).then((res: any) => {
        if (res.result !== undefined) {
            selGrabarDatosPersonales(false, '', res.result, Postulaciones);
        } else {
            selGrabarDatosPersonales(true, res.errorDetails, res.result, Postulaciones);
        }
    });

    // then((res: IServiceResult<any>) => {
    //     if (res.result !== undefined) {
    //         selGrabarDatosPersonales(false, '', res.result);
    //     }
    //     else {
    //         selGrabarDatosPersonales(true, res.errorDetails, res.result);
    //     }
    // });
};

export const ObtieneDatosTipoPersonaPorPostulacion = (
    selListaDatosTipoPersona: any,
    headers: any,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    tipoPersona: number,
    idPeriodo: number,
    idRefirma: number
) => {
    let list: Array<IViewRepresentanteFinanciero> = [];
    let _list: Array<IViewRepresentanteFinancieroCmb> = [];
    let _list2: Array<IViewRepresentanteFinancieroCmb> = [];
    SVCDatosPersonales.ObtieneDatosTipoPersonaPorPostulacion(
        headers,
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        tipoPersona,
        idPeriodo,
        idRefirma
    ).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            list.push({
                idPersona: data.idPersona,
                run: data.run,
                dv: data.dv === null || data.dv === undefined ? '' : data.dv,
                nombres: data.nombres === null || data.nombres === undefined ? '' : data.nombres.trim(),
                primerApellido:
                    data.primerApellido === null || data.primerApellido === undefined ? '' : data.primerApellido.trim(),
                segundoApellido: (data.segundoApellido === null || data.segundoApellido === undefined
                    ? ''
                    : data.segundoApellido
                ).trim(),
                fechaNacimiento:
                    data.fechaNacimiento === null || data.fechaNacimiento === undefined ? '' : data.fechaNacimiento,
                codigoComuna: data.codigoComuna,
                nombreComuna:
                    data.nombreComuna === null || data.nombreComuna === undefined ? '' : data.nombreComuna.trim(),
                direccion: data.direccion === null || data.direccion === undefined ? '' : data.direccion.trim(),
                telefono: data.telefono,
                email: data.email === null || data.email === undefined ? '' : data.email.trim(),
                codSexo: data.codSexo,
                sexo: data.sexo === null || data.sexo === undefined ? '' : data.sexo.trim(),
                idPais: data.idPais,
                pais: data.pais === null || data.pais === undefined ? '' : data.pais.trim(),
                idNacionalidad: data.idNacionalidad,
                nacionalidad:
                    data.nacionalidad === null || data.nacionalidad === undefined ? '' : data.nacionalidad.trim(),
                runFormato: data.runFormato === null || data.runFormato === undefined ? '' : data.runFormato.trim(),
                nombreCompleto:
                    data.nombreCompleto === null || data.nombreCompleto === undefined ? '' : data.nombreCompleto.trim(),
            });

            _list.push({ ID: 1, Descripcion: 'RUT: ' + list[0].runFormato });
            _list.push({ ID: 2, Descripcion: 'NOMBRE COMPLETO: ' + list[0].nombreCompleto });
            _list.push({
                ID: 3,
                Descripcion:
                    'FECHA DE NACIMIENTO: ' +
                    (format(new Date(list[0].fechaNacimiento), 'YYYY-MM-DD') === '1900-01-01'
                        ? ''
                        : format(new Date(list[0].fechaNacimiento), 'DD-MM-YYYY')),
            });
            _list.push({ ID: 4, Descripcion: 'NACIONALIDAD: ' + list[0].nacionalidad });

            _list2.push({ ID: 1, Descripcion: 'DIRECCIÓN: ' + list[0].direccion });
            _list2.push({ ID: 2, Descripcion: 'COMUNA: ' + list[0].nombreComuna });
            _list2.push({ ID: 3, Descripcion: 'TELÉFONO: +56 ' + list[0].telefono });
            _list2.push({ ID: 4, Descripcion: 'EMAIL: ' + list[0].email });

            selListaDatosTipoPersona(false, '', list, _list, _list2);
        } else {
            selListaDatosTipoPersona(true, res.errorDetails, list, _list, _list2);
        }
    });
};

export const BloqueoPorRut = (
    selBloqueoPorRut: any,
    rutAlumno: number,
    codigoNegocio: number,
    codigoPrograma: string,
    anioPromocion: number,
    periodoPromocion: number,
    codigoPlanificacion: number,
    rutPersona: number,
) => {
    SVCDatosPersonales.BloqueoPorRut(
        rutAlumno,
        codigoNegocio,
        codigoPrograma,
        anioPromocion,
        periodoPromocion,
        codigoPlanificacion,
        rutPersona,
    ).then((res: any) => {
        if (res.result !== undefined) {
            selBloqueoPorRut(false, '', res.result);
        } else {
            selBloqueoPorRut(true, res.errorDetails, res.result);
        }
    });
};
